import {checkmarkDoneOutline, playOutline, stopCircleOutline} from "ionicons/icons";
import {TicketStatus} from "app/gql/graphqlSchema";
import {freeze} from "immer";
import {UnreachableCaseError} from "ts-essentials";

export const ticketStatusIcon = freeze<Record<TicketStatus, string>>({
  [TicketStatus.Todo]: stopCircleOutline,
  [TicketStatus.InProgress]: playOutline,
  [TicketStatus.Done]: checkmarkDoneOutline
});

export const ticketItemColor = (status: TicketStatus) => {
  switch (status) {
    case TicketStatus.Todo:
      return "incomplete";
    case TicketStatus.InProgress:
      return "highlight";
    case TicketStatus.Done:
      return "completed";
    default:
      throw new UnreachableCaseError(status);
  }
};
